<div class="v2-phone-input">
  <label class="country-label">Country</label>
  <select
    class="country-select"
    [ngModel]="selectedCountry"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="nationalControl.disabled"
    (ngModelChange)="onCountryChange($event)"
    aria-label="Country"
  >
    <option *ngFor="let country of countries" [ngValue]="country.code">
      {{ country.flag }} {{ country.name }} (+{{ country.callingCode }})
    </option>
  </select>

  <v2-form-field [labelText]="labelText">
    <input
      v2Input
      type="tel"
      inputmode="tel"
      autocomplete="tel-national"
      [placeholder]="placeholder"
      [required]="required"
      [formControl]="nationalControl"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />
    <v2-error-text>{{ errorMessage }}</v2-error-text>
  </v2-form-field>
</div>
